import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, isValidElement, useId, } from 'react';
import { cn } from './cn.js';
/**
 * Accessible label + control + message wrapper.
 *
 * Generates a stable id, wires `htmlFor`/`id`, and injects `aria-describedby`
 * (hint or error) and `aria-invalid` onto the single child control by cloning
 * it. Pass exactly one form element as the child.
 */
export function Field({ label, children, hint, error, required, className }) {
    const id = useId();
    const hintId = `${id}-hint`;
    const errorId = `${id}-error`;
    const describedBy = error ? errorId : hint ? hintId : undefined;
    const control = isValidElement(children)
        ? cloneElement(children, {
            id,
            'aria-describedby': describedBy,
            'aria-invalid': error ? true : undefined,
            required: required || undefined,
        })
        : children;
    return (_jsxs("div", { className: cn('flex flex-col gap-1.5', className), children: [_jsxs("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: [label, required && (_jsx("span", { className: "ml-0.5 text-destructive", "aria-hidden": "true", children: "*" }))] }), control, error ? (_jsx("p", { id: errorId, className: "text-xs text-destructive", children: error })) : hint ? (_jsx("p", { id: hintId, className: "text-xs text-muted-foreground", children: hint })) : null] }));
}
